<div class="comments-container">
    <div class="comments-header">
        <p class="comments-header-title">{{title()}}</p>
        <app-link [ngClass]="{'spin': autoRefreshEnabled()}" iconClass="dx-icon-refresh" (onClick)="toggleAutoRefresh()"></app-link>
        <app-link iconClass="dx-icon-remove" (onClick)="close()"></app-link>
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</div>